module.exports = __webpack_public_path__ + "img/Frage2_1024x768.f0d57a44.jpg";